<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess()" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <w-input class="mt4" label="Tarikh *" type="date" v-model="form.tarikh" :validators="[validators.required]"/>
            <div class="spacer"></div>
            <!-- <template v-if="form.id == 0"> -->
              <z-select class="mt4" :items="se_katalog" label="ID Ternakan *" v-model="form.se_katalog_id" :validators="[validators.required]"/>
            <!-- </template>
            <template v-else>
              <br>
              <w-input label="ID Ternakan *" v-model="form.ternakan" disabled :validators="[validators.required]"/> 
            </template> -->
            <div class="spacer"></div>
            <br>
            <w-input label="Jumlah Panjatan Palsu " type="number" v-model="form.jumlah_penjatan_palsu" />
            <!-- <div class="spacer"></div>
            <br>
            <w-input label="Bil. Pungutan *" type="number" v-model="form.bil_pungutan" :validators="[validators.required]"/> -->
            <div class="spacer"></div>
            <br>
            <w-input label="Warna Benih *" type="text" v-model="form.warna" :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <w-input
              class="mb2"
              label="Nama Operator *"
              label-position="inside"
              inner-icon-right="wi-search"
              v-model="form.name" @click="pengguna()" :validators="[validators.required]">
            </w-input>
           
          </div>
          <div class="mx2"></div>
          <div class="grow " >
            <w-input class="mt4" label="Masa Pungutan *" type="time" v-model="form.masa" :validators="[validators.required]"/>
            <div class="spacer"></div>
            <!-- <br> -->
            <w-select class="mt4" :items="lkp_ejakulasi" label="Nombor Ejakulasi *" v-model="form.lkp_ejakulasi_id" :validators="[validators.required]"/>
            <!-- <w-input label="No. Ejakulasi (1-3) *" type="number" v-model="form.no_ejekulasi" :disabled="form.id > 0" :validators="[validators.required]"/> -->
            <div class="spacer"></div>
            <br>
            <w-input label="Tujahan (0-5)" type="number" v-model="form.tujahan" max="5" min="0" @keyup="tujahan()"/>
            <div class="spacer"></div>
            <br>
            <w-input label="Libido (0-10)" type="number" v-model="form.libido" max="10" @keyup="libido()"/>
            <div class="spacer"></div>
            <br>
            <w-input label="Isipadu Semen (ml) *" type="number" v-model="form.isipadu" :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <w-input label="Skor Ketumpatan (0-5)" max="5" type="number" v-model="form.skor_ketumpatan" @keyup="skorKetumpahan()"/>
          </div>
        </div>
          <w-textarea class="mt4"  label="Catatan"  v-model="form.catatan" v-if="$zutil.anyRole(['1', '3', '11'])"/>
        <w-flex class="mt3" wrap align-center justify-end>
                    <w-button class="my1" v-on="on"  :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
                    <w-icon class="mr1" md >fal fa-save</w-icon>SIMPAN
                </w-button>
            &nbsp;
                    <w-button class="my1" v-on="on" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
                    <w-icon class="mr1" md >fal fa-paper-plane</w-icon>HANTAR
                </w-button>
        </w-flex>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </w-form>
	  </z-page>
    <w-dialog
      v-model="dialog.show"
      :fullscreen="dialog.fullscreen"
      :width="dialog.width"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
         <w-icon class="mr2">fal fa-cog</w-icon>
         Pilih Operator 
      </template>

      <w-form 
         ref="form" 
         v-model="dialog.valid"
         @validate="submit"
         @success="success"
      >
          <w-flex justify-center align-center>
              <div class="xs8">
                  <w-input
                      label="No ID | Nama"
                      v-model="carian_profil.q"
                  >
                  </w-input>
              </div>
              <div class="xs4">
                  <w-button class="ml1" @click="cariProfil">Cari</w-button>

                  <w-button 
                      class="ml1" 
                      @click="tambahPrfile()"
                      v-if="$zutil.anyRole(['1', '3', '11'])"
                      >
                      Tambah
                  </w-button>
              </div>
          </w-flex>
        <div class="w-table-wrap" style="max-height: 400px;">
          <div class="table-profil-scrol">
          <table class="w-table" color="light" >
            <thead>
              <tr>
                <th class="w-table__header  text-left" width="1%">No</th>
                <th class="w-table__header  text-left">Nama</th>
                <th class="w-table__header  text-left">E-mel</th>
                <th class="w-table__header  text-left">Nombor Telefon</th>
                <th class="w-table__header  text-left">Pilih</th>
                <th class="w-table__header  text-left">Padam</th>
              </tr>
            </thead>

            <tbody>
              <template v-if="user_list.length == 0">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
                </tr>
              </template>
              <template v-for="(dt, ind) in user_list">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" >{{ind+1}}</td>
                  <td class="w-table__cell text-left">{{ dt.no_id }} | {{ dt.label.charAt(0).toUpperCase() + dt.label.slice(1) }}</td>
                  <td class="w-table__cell text-left" >{{dt.email}}</td>
                  <td class="w-table__cell text-left" >{{dt.no_tel}}</td>
                  <td class="w-table__cell text-center">
                    <template v-if="form.pembekal_id == dt.value">
                       <w-radio
                        class="mr2"
                        v-model="form.pembekal_id"
                        @click="pilihProfil(dt)"
                      ></w-radio>
                    </template>
                    <template v-else>
                      <w-radio
                        class="mr2"
                        @click="pilihProfil(dt)"
                      ></w-radio>
                    </template>

                  </td>
                  <td class="w-table__cell text-left" >
                     <w-button class="fs-2" bg-color="error-dark1" dark tile @click="destroy1(dt.value)">
                       <w-icon xs class="mr2">fal fa-trash</w-icon>
                     </w-button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          </div>
        </div>
      </w-form>
      <template #actions>
         <div class="spacer" />
         <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      </template>
    </w-dialog>
    <w-dialog
      v-model="dialog_add.show"
      :fullscreen="dialog_add.fullscreen"
      :width="dialog_add.width"
      :persistent="dialog_add.persistent"
      :persistent-no-animation="dialog_add.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
         <w-icon class="mr2">fal fa-cog</w-icon>
         Tambah profil
      </template>

      <w-form 
         ref="form" 
         v-model="dialog_add.valid"
         @validate="submitProfil"
         @success="success"
      >
      <div class="spacer"></div>
        <w-flex wrap :gap="2">
          <div class="grow mb4" style="min-width: 200px">
            <w-input
           outline
           label="No. Kad Pengenalan *"
           class="mt3"
           type="text"
           placeholder="No. Kad Pengenalan"
           name="no_id"
           v-model="form_profil.no_id"
           :validators="[validators.required]"
         />
            <div class="spacer"></div>
            <br>
            <w-input
            outline
            label="Emel *"
            class="mt3"
            type="email"
            placeholder="Sila Masukkan Emel"
            name="email"
            v-model="form_profil.email"
            :validators="[validators.required, validators.email]"
         />
          </div>
          <div class="grow mb4" style="min-width: 200px">
            <w-input
           outline
           label="Nama Penuh *"
           class="mt3"
           type="text"
           placeholder="Nama Penuh"
           name="name"
           v-model="form_profil.name"
           :validators="[validators.required]"
         />
            <div class="spacer"></div>
            <br>
            <w-input
             outline
             label="Nombor Telefon *"
             class="mt3"
             type="tel"
             placeholder="Sila Masukkan Nombor Telefon"
             name="no_tel"
             v-model="form_profil.no_tel"
             :validators="[validators.required, validators.numeric]"
         />
          </div>
        </w-flex>
        <!-- <div class="spacer"></div>
        <w-textarea 
            outline 
            label="Alamat*"
            placeholder="Sila Masukkan Alamat"
            class="mt3"
            name="alamat"
            v-model="form_profil.alamat"
            type="text-area"
            :validators="[validators.required]"/>
        <div class="spacer"></div>
        <br>
        <template v-if = "form.p == 1">
         <w-select 
            outline
            :items="poskod" 
            label="Poskod"  
            v-model="form.lkp_poskod_id"
            @input="checkPoskod()"
            />
        </template>
        <template v-else>
          <w-input
             outline
             label="Poskod"
             class="mt3"
             type="tel"
             placeholder="Sila Masukkan Poskod"
             name="poskod"
             v-model="form_profil.kode"
             @change="getPoskodUtama()"
             :validators="[validators.required, validators.numeric]"
         />
        </template>
        <br>
        <w-select 
            outline
            :items="bandar" 
            label="Bandar *"  
            v-model="form_profil.lkp_bandar_id"
            @input="getPoskod(1)"
            :validators="[validators.required]"/>
        <div class="spacer"></div>
        <br>
        <w-select 
            outline
            :items="negeri" 
            label="Negeri *"  
            v-model="form_profil.lkp_negeri_id"
            @input="getBandar(1)"
            :validators="[validators.required]"/> -->
      </w-form>
        

    
      <template #actions>
         <div class="spacer" />
         <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog_add.show = false">TUTUP</w-button>
         <w-button 
         class="ml1" 
         :loading="dialog_add.loading"
         :disabled="dialog_add.valid === false"
         @click="$refs.form.validate()"
         >
           SIMPAN
         </w-button>
      </template>
    </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_form: [Array, Object],
    d_se_katalog : [Array, Object],
    d_negeri: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'se.pemungutan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pemungutan Semen Ternakan', route: '/se/pemungutan' },
      ],
      title : 'Tambah Baka Jantan',
      form : this.d_form,
      se_katalog : this.d_se_katalog,
      negeri : this.d_negeri,
      carian_profil: { q: "" },
      country : [],
      bandar : [],
      poskod : [],
      negara : [],
      peran : [],
      form_profil: [],
      user_list: [],
      dialog: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
      },
      dialog_add: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
         item: {name: '', email: '', mobile: ''}
      },
      lkp_ejakulasi : []
      
    }
  },
  methods: {
   destroy1(id){
      this.$swal({
        title: 'Anda Pasti?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete('pengguna.destroy',{ id: id , operator:1},{})
          .then(res => {
            // this.sending = false;
            // this.$inertia.visit(this.$page.url)

            this.$zutil.notify("Berjaya dipadam", 'error');
            this.getUserList();
            // this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })
   },
   libido(){
      if(this.form.libido > 10){
         this.form.libido = 10;
      }
   },
   tujahan(){
      if(this.form.tujahan > 5){
         this.form.tujahan = 5;
      }
   },
   skorKetumpahan(){
      if(this.form.skor_ketumpatan > 5){
         this.form.skor_ketumpatan = 5;
      }
   },
    send(hantar){
      this.form.hantar = hantar
    },
    onSuccess(){
     if(this.form.hantar == 1){
       this.$swal({
           title: 'Anda Pasti?',
           type: 'warning',
           showCancelButton: true,
           confirmButtonColor: '#3085d6',
           confirmButtonClass: '#d33',
           confirmButtonText: 'Ya',
           cancelButtonText: 'Tidak'
         }).then((result) => {
           if (result.value) {
             if(this.form.id){
               this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
               .then(res => {
                 if (typeof this.onAfterEdit === "function") {
                   this.onAfterEdit()
                 }
                 if(res == 'No Ejakulasi telah dipilih'){
                   this.form.hantar = 0;
                   this.$zutil.notify('No Ejakulasi telah dipilih!', false);
                 }
                 else if (this.form.hantar == 1) {
                   this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id));
                 } else {
                   this.$zutil.notify("Berjaya disimpan", true);
                 }
               })
               .catch(err => {
                 if (err.response && err.response.status === 422) {
                   const errorMessage = err.response.data.message || 'No. Batch telah wujud.';
                   this.$zutil.notify(errorMessage, false);
                   this.form.hantar = 0;
                 } else {
                   this.$zutil.notify("Ralat berlaku semasa mengemaskini data.", false);
                 }
               });
             } else {
               this.$zcomm.post(this.resourceurl+'.store' , this.form)
               .then(res => {
                 if (typeof this.onAfterAdd === "function") {
                   this.onAfterAdd()
                 }
                 this.$zutil.notify("Berjaya dihantar", true);
                 this.$inertia.visit(this.$route('se.pemungutan.show', res.id));
               })
               .catch(err => {
                 if (err.response && err.response.status === 422) {
                   const errorMessage = err.response.data.message || 'No. Batch telah wujud.';
                   this.$zutil.notify(errorMessage, false);
                   this.form.hantar = 0;
                 } else {
                   this.$zutil.notify("Ralat berlaku semasa menghantar data.", false);
                 }
               });
             }
           }
         })
     } else {
       if (this.form.id > 0) {
         this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
         .then(res => {
           if (typeof this.onAfterEdit === "function") {
             this.onAfterEdit()
           }
           if (this.form.hantar == 1) {
               this.$inertia.visit(this.$route('se.pemungutan.form', this.form.id));
           } else {
               this.$zutil.notify("Berjaya disimpan", true);
               this.$inertia.visit(this.$route('se.pemungutan.form', this.form.id));
           }
         })
         .catch(err => {
           if (err.response && err.response.status === 422) {
             const errorMessage = err.response.data.message || 'No. Batch telah wujud.';
             this.$zutil.notify(errorMessage, false);
             this.form.hantar = 0;
           } else {
             this.$zutil.notify("Ralat berlaku semasa menyimpan data.", false);
           }
         });
       } else {
         this.$zcomm.post(this.resourceurl+'.store' , this.form)
         .then(res => {
           if (typeof this.onAfterAdd === "function") {
             this.onAfterAdd()
           }
           this.$zutil.notify("Berjaya disimpan", true);
           this.$inertia.visit(this.$route('se.pemungutan.form', res.id));
         })
         .catch(err => {
           if (err.response && err.response.status === 422) {
             const errorMessage = err.response.data.message || 'No. Batch telah wujud.';
             this.$zutil.notify(errorMessage, false);
             this.form.hantar = 0;
           } else {
             this.$zutil.notify("Ralat berlaku semasa menyimpan data.", false);
           }
         });
       }
     } 
   },


    setJantina(id){

      this.form.jantina = id
    },

    getJurusan(i){
      this.form.lkp_jurusan_id = ''
      this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
        this.lkp_jurusan = res
      })
    },

    getBaka(i){
      this.form.lkp_baka_id = ''
      this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
        this.lkp_baka = res
      })
    },
    
    getNegara(){
      this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
        this.negara = res
      })
    },

    getEjakulasi(){
      this.$zcomm.get(this.api_service + 'lookup/ejakulasi', {}).then(res => {
        this.lkp_ejakulasi = res
      })
    },

    getBandar(item){
      if (item == 2) {
        this.form_profil.lkp_poskod_id = '';
        this.form_profil.lkp_bandar_id = '';
      }
      if(item == 2 || (item == 1 && this.form_profil.lkp_bandar_id != '')){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form_profil.lkp_negeri_id, {}).then(res => {
        this.bandar = res
        })
      }
      if(item == 0){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form_profil.lkp_negeri_id, {}).then(res => {
        this.bandar = res
        })
      }
    },

    getPoskod(item){
      if (item == 2 || this.form_profil.lkp_bandar_id == '') {
      this.form_profil.lkp_poskod_id = '';
      }
      if(item == 2 || (item == 1 && this.form_profil.lkp_bandar_id != '')){
      this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.form_profil.lkp_bandar_id, {}).then(res => {
        this.poskod = res
      })
      }
    },

    getPoskodUtama(){
      this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.form_profil.kode, {}).then(res => {
        // this.form.p = res.p
        this.form_profil.lkp_negeri_id = res.lkp_negeri_id
        this.form_profil.lkp_bandar_id = res.lkp_bandar_id
        this.form_profil.lkp_poskod_id = res.lkp_poskod_id
        this.getPoskod(0)
        this.getBandar(0)
      })
    },

    checkPoskod(){
      if(this.form_profil.lkp_poskod_id == null){
         this.form_profil.p = 0
      }
    },
    tambahPrfile(){
      this.form_profil = {
           id : null,
           no_id : null,
           name : null,
           email:'',
           no_tel: '',
           alamat: '',
           password: 123123,
           pembekal: null,
           status : 1,
           kode: '',
           lkp_poskod_id: '',
           lkp_bandar_id : '',
           lkp_negeri_id :'',
           operator:1,
      }
      this.dialog_add.show = true
      this.form_profil.saveButton = "Save"
    },
    submitProfil(){
      this.$zcomm.post('pengguna',this.form_profil).then(res => {
          if (res == "No. Kad Pengenalan sudah wujud!" || res == "Email sudah wujud!") {
            if (res == "No. Kad Pengenalan sudah wujud!")
                {
                  this.$zutil.notify("No. Kad Pengenalan sudah wujud!", false);
                }
            if (res == "Email sudah wujud!")
                {
                  this.$zutil.notify("Email sudah wujud!", false);
                }
          }else{
            this.$zutil.notify("Berjaya disimpan");
            this.getUserList();
            this.dialog_add.show = false;
          }
        })
        .catch(err => {
        })
    },
    pengguna(){
      this.getUserList();
      this.dialog.show = true
      this.form.saveButton = "Save"
    },
    pilihProfil(dt) {
        this.form.user_id = dt.value;
        this.form.name = dt.label;
        this.dialog.show = false
    },

    cariProfil() {
        if (this.carian_profil.q.length > 1) {
            this.$zcomm
                .get(
                    this.api_service + "lookup/user_list/2",
                    this.carian_profil,
                    {}
                )
                .then((res) => {
                    this.user_list = res;
                });
        }
    },

    getUserList(){
      this.$zcomm.get(this.api_service + 'lookup/user_list/2', {}).then(res => {
        this.user_list = res
      })
    },

    tutup(){
      this.$inertia.visit(window.route('se.pemungutan.index'));
    },

    
  
  },

  watch: {

  },
  mounted() {
    this.getEjakulasi()
    if (this.form.id == 0) {
      var today = new Date();
       this.form.tarikh = today.toISOString().split('T')[0];
    }
    if(this.form.id > 0)
    {
      this.title = 'Kemaskini Pemungutan Semen Ternakan '
    }
    else
    {
      this.title = 'Tambah Pemungutan Semen Ternakan'
    }
   
    
  }
    
}
</script>
